import React from 'react';
import { Button } from 'reactstrap';

import history from '../../utils/history';
import { sanitizeRichText } from '../../utils/reRenderFormulas';
import {
  getSessionStorageItem,
  removeSessionStorageItem,
} from '../../utils/sessionStorage';
import CircularLoading from '../Common/CircularLoading/CircularLoading';
import TimerExpiredModal from '../Common/CommonDailysQuiz/TimerExpiredModal/TimerExpiredModal';
import { Desktop, Mobile } from '../Common/const';
import HelpButton from '../Common/HelpButton/HelpButton';
import ProgressBar from '../Common/ProgressBar';
import QuestionCard from '../Question/QuestionCard';
import Timer from './Timer';

class Daily20Quiz extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      update: false,
      currentQuestion: 0,
      timer: 1200,
      quizLoaded: false,
      answerId: null,
      timerSetted: false,
      goToReview: false,
      initialResultsDetailed: [],
      isRetake: !!history.location?.state?.isRetake,
      idDailyQuiz: history.location?.state?.idDailyQuiz,
      openModelTimerExpired: false,
    };

    this.timer = null;
  }

  componentDidMount() {
    this.props.resetDailyQuizHistory();
    // Reset previous quiz state before loading new one to prevent
    // stale data (e.g. question counter from a PFE quiz carrying over to SKT)
    this.props.setDailyQuiz(null);
    this.props.loadDailyQuiz(this.state.idDailyQuiz, this.state.isRetake);
    if (getSessionStorageItem('quiz')) {
      removeSessionStorageItem('quiz');
    }
  }

  getClickedState = () => {
    if (
      Array.isArray(this.state.questions) &&
      this.state.questions.length > 0
    ) {
      const clicked = this.state.questions[this.state.currentQuestion]?.clicked;
      const answered =
        this.state.questions[this.state.currentQuestion]?.answered;
      return Boolean(clicked || answered);
    }
    return false;
  };

  updateIsCorrect = (Correct) => {
    this.setState({
      isCorrect: Correct,
    });
  };

  componentWillUnmount() {
    this.clearInterval(this.timer);
    this.setState({
      timerSetted: false,
      quizLoaded: false,
      goToReview: false,
    });
    removeSessionStorageItem('isReviewingLastDailyQuiz');
    removeSessionStorageItem('isReviewingLastQualDailyQuiz');
  }

  setClicked = (answerId) => {
    const questions = [...this.state.questions];
    const question = {
      ...questions[this.state.currentQuestion],
      clicked: true,
    };
    questions[this.state.currentQuestion] = question;

    this.setState({
      questions,
      answerId,
    });
  };

  submitAnswer = () => {
    const id_question = this.state.questions[this.state.currentQuestion].id;
    const id_answer = this.state.answerId;
    const currentresults = this.state.initialResultsDetailed;
    const quiz = this.state.isRetake ? this.props.quizRetake : this.props.quiz;

    currentresults.push({
      id_question,
      id_answer,
    });

    this.setState({ initialResultsDetailed: currentresults });
    const nextQuestion = this.state.nextQuestion;
    if (this.state.questionCount === nextQuestion) {
      if (!this.state.isRetake) {
        this.props.checkDailyQuizStatus();
      }
      this.setState(
        {
          goToReview: true,
        },
        () =>
          this.props.submitDailyQuiz(
            quiz.id,
            currentresults,
            this.state.isRetake,
          ),
      );
      this.clearInterval(this.timer);
    } else {
      this.props.updateDailyQuiz(quiz.id, currentresults, this.state.isRetake);

      this.setState({
        currentQuestion: nextQuestion,
        nextQuestion: nextQuestion + 1,
        question: this.state.questions[nextQuestion],
        answerId: null,
      });
    }
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const nextQuiz = this.state.isRetake
      ? nextProps.quizRetake
      : nextProps.quiz;

    if (
      ((!this.state.isRetake && nextQuiz?.resultsDetailed) ||
        (this.state.isRetake && nextQuiz?.retakeResultsDetailed)) &&
      this.state.initialResultsDetailed.length === 0
    ) {
      if (nextQuiz.reviewHistoryMode) {
        window.location.reload();
      }
      this.setState({
        initialResultsDetailed: this.state.isRetake
          ? JSON.parse(nextQuiz?.retakeResultsDetailed)
          : JSON.parse(nextQuiz?.resultsDetailed),
      });
    }
    if (
      nextQuiz &&
      nextQuiz.questions &&
      nextQuiz.questions?.length > 0 &&
      !this.state.quizLoaded
    ) {
      // CHECK ANSWERED QUESTIONS AND SET CURRENT QUESTION
      const questions = nextQuiz.questions;
      if (nextQuiz.reviewHistoryMode && !this.state.isRetake) {
        window.location.reload();
      }
      const detailed = this.state.isRetake
        ? nextQuiz?.retakeResultsDetailed
        : nextQuiz?.resultsDetailed;

      if (detailed) {
        const currentQuestion = this.state.isRetake
          ? JSON.parse(detailed)?.length
          : JSON.parse(detailed)?.length;
        const question = questions[currentQuestion];
        const questionCount = questions.length;
        const nextQuestion = currentQuestion + 1;
        this.setState({
          question,
          questionCount,
          nextQuestion,
          currentQuestion,
          quizLoaded: true,
          questions,
        });
        if (!this.state.timerSetted) {
          const remainingTime = this.state.isRetake
            ? (nextQuiz.retakeTimeRemaining ?? 0)
            : (nextQuiz.timeRemaining ?? 0);

          if (remainingTime === 0) {
            this.setState({ openModelTimerExpired: true });
          }

          this.setState(
            {
              timer: remainingTime,
              timerSetted: true,
            },
            () => this.startTimer(),
          );
        }
      }
    }

    if (nextProps.submitDailyQuizSuccess) {
      this.props.setSubmitDailyQuizSuccess(false);
      this.props.setDailyTimeOut(false);
      if (this.state.isRetake && !this.state.openModelTimerExpired) {
        history.push('/app/daily-quiz');
      } else if (!this.state.openModelTimerExpired) {
        history.push('/app/daily20quizResults');
      }
    }
  }

  clearInterval = (timer) => {
    clearInterval(timer);
  };

  startTimer = () => {
    const quiz = this.state.isRetake ? this.props.quizRetake : this.props.quiz;
    this.timer = setInterval(() => {
      let timer = this.state.timer;
      if (timer > 0) {
        this.setState({ timer: timer - 1 });
      }
      timer -= 1;
      if (timer <= 0) {
        if (quiz) {
          this.setState({ openModelTimerExpired: true });
          const currentresults = this.state.initialResultsDetailed;
          this.props.submitDailyQuiz(
            quiz.id,
            currentresults,
            this.state.isRetake,
          );
        }
        this.clearInterval(this.timer);
      }
    }, 1000);
  };

  renderSymbols = (text) => {
    const isNewQuestion = /<\/?[a-z][\s\S]*>/i.test(text);
    let result = text;
    if (!isNewQuestion) {
      result = result.replace(/</g, '&lt;');
      result = result.replace(/>/g, '&gt;');
    }
    return result;
  };

  exitQuiz = () => {
    history.push('/app/daily-quiz');
    // this.props.setDailyQuiz(null);
    if (!this.state.isRetake) {
      this.props.checkDailyQuizStatus();
    }
  };

  render() {
    let buttonLabel = 'Submit answer';
    if (this.state.questionCount === this.state.nextQuestion) {
      buttonLabel = this.state.isRetake ? 'Finish retake' : 'Grade my quiz';
    }

    if (this.props.loadDailyQuizWaiting || !this.state.quizLoaded) {
      return (
        <div className="loading-quiz-container">
          <CircularLoading />
        </div>
      );
    }
    const htmlQuestion = `<h3><b>Q:</b> ${sanitizeRichText(
      this.renderSymbols(
        this.state.question?.text ? this.state.question.text : '',
      ),
    )}</h3>`;

    return (
      <div className="question-main-body">
        <div className="question-background">
          <div className="question-wrapper daily20quiz">
            <Desktop>
              <h2>Daily 20 Quiz</h2>
              <div className="row ml-0 mr-0">
                <div className="col-lg-9 col-md-8 col-sm-12">
                  <span
                    className="questions-p"
                    dangerouslySetInnerHTML={{
                      __html: htmlQuestion,
                    }}
                  />
                </div>
                <div className="col-lg-3 col-md-4 col-sm-12">
                  <Timer time={this.state.timer} exitQuiz={this.exitQuiz} />
                </div>
              </div>
            </Desktop>
            <Mobile>
              <div className="row">
                <div className="col-12">
                  <Timer time={this.state.timer} exitQuiz={this.exitQuiz} />
                </div>
                <div className="col-12 questions-p">
                  <span
                    dangerouslySetInnerHTML={{
                      __html: htmlQuestion,
                    }}
                  />
                </div>
              </div>
            </Mobile>
          </div>
        </div>
        <div className="question-wrapper mt-dynamic">
          <TimerExpiredModal
            className="modal-dialog-centered"
            open={this.state.openModelTimerExpired}
            close={this.exitQuiz}
          />
          <QuestionCard
            {...this.state.question}
            renderSymbols={this.renderSymbols}
            clicked={this.getClickedState()}
            questionClicked={this.getClickedState}
            setClicked={this.setClicked}
            getClickedState={this.getClickedState}
            updateIsCorrect={this.updateIsCorrect}
            allowToChangeAnswer
          />
          <Desktop>
            <div className="d-flex button-row mt-2 ml-0 mr-0">
              <div className="col-12 col-md-9 col-sm-12 mt-3">
                <ProgressBar
                  total={this.state.questionCount}
                  progress={this.state.currentQuestion + 1}
                  title
                />
              </div>
              <div className="col-12 col-sm-12 col-md-3 mt-2 text-right p-0 d-block">
                {this.getClickedState() ? (
                  <Button
                    color="primary"
                    className="mt-4"
                    disabled={
                      this.state.questionCount === this.state.nextQuestion &&
                      this.props.submitDailyQuizWaiting
                    }
                    onClick={this.submitAnswer}
                  >
                    {buttonLabel}
                  </Button>
                ) : null}
              </div>
            </div>
            <div className="row button-row mt-3 mx-0">
              <div className="feedback d-inline-block ml-auto float-right">
                <HelpButton question={this.state.question} />
              </div>
            </div>
          </Desktop>
          <Mobile>
            <div className="p-2">
              <ProgressBar
                total={this.state.questionCount}
                progress={this.state.currentQuestion + 1}
                title
              />
            </div>
            <div className="row ml-0 mr-0 button-row mt-3 mx-0">
              <div className="feedback d-inline-block ml-auto float-right">
                <HelpButton question={this.state.question} />
              </div>
            </div>
            <div className="col-12">
              {this.getClickedState() ? (
                <Button
                  block
                  color="primary"
                  className="mt-4"
                  disabled={
                    this.state.questionCount === this.state.nextQuestion &&
                    this.props.submitDailyQuizWaiting
                  }
                  onClick={this.submitAnswer}
                >
                  {buttonLabel}
                </Button>
              ) : null}
            </div>
          </Mobile>
        </div>
      </div>
    );
  }
}

export default Daily20Quiz;
